<ng-container *ngIf="viewModel$ | async as vm">
  <div class="modal-header">
    <h4 class="modal-title">Callbacks</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table mt-1 table-striped" *ngIf="!vm.initial">
      <thead>
        <tr>
          <th scope="col">Campaign</th>
          <th scope="col">Name</th>
          <th scope="col">State</th>
          <th scope="col">Contact Datetime</th>
          <th scope="col">Agent Datetime</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="vm.callbacks === undefined">
          <td colspan="6">Loading...</td>
        </tr>
        <tr *ngIf="vm.callbacks && vm.callbacks.length === 0">
          <td colspan="6">No Records Found...</td>
        </tr>
        <tr
          *ngFor="
            let r of vm.callbacks | slice: (page - 1) * pageSize:page * pageSize
          "
        >
          <td class="small align-bottom">{{ r.campaignDescription }}</td>
          <td class="small align-bottom">{{ r.name }}</td>
          <td class="small align-bottom">{{ r.state }}</td>
          <td class="small align-bottom">
            {{ r.cbDatetime | date: "dd/MM/yyyy HH:mm" }}
          </td>
          <td class="small align-bottom">
            {{ r.cbDatetimeAgent | date: "dd/MM/yyyy HH:mm" }}
          </td>
          <td *ngIf="r.dueNow === 'Yes'" class="align-bottom">
            <button
              class="btn btn-secondary btn-sm"
              (click)="selectRecord(r.recordId, r.campaignId)"
            >
              Select
            </button>
          </td>
          <td class="small align-bottom" *ngIf="r.dueNow === 'No'">Not Due</td>
        </tr>
      </tbody>
    </table>

    <ngb-pagination
      [collectionSize]="callbackCount"
      [(page)]="page"
      [pageSize]="pageSize"
      [directionLinks]="false"
    ></ngb-pagination>
  </div>
</ng-container>
